import { CircleGrid } from "react-awesome-shapes/dist/shapes/circlegrid";
import { Donut } from "react-awesome-shapes/dist/shapes/donut";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";

import {
  childSafeWellbeing,
  childSafeConduct,
  covidSafePlan,
  privacyPolicy,
  cancellationPolicy,
  refundPolicy,
} from "../../";

const Policies = () => {
  const policies = {
    c: [
      {
        name: "Child Safe and Wellbeing Policy",
        href: childSafeWellbeing,
      },
      { name: "Child Safe Code of Conduct", href: childSafeConduct },
      {
        name: "COVIDSafe Plan for In Person Learning",
        href: covidSafePlan,
      },
    ],
    p: [
      { name: "Privacy Policy", href: privacyPolicy },
      {
        name: "Private Tutoring Lesson Cancellation Policy",
        href: cancellationPolicy,
      },
    ],
    r: [{ name: "Refund Policy", href: refundPolicy }],
  };
  return (
    <div className="py-16 xl:py-36 px-4 sm:px-6 lg:px-8 bg-white overflow-hidden">
      <div className="max-w-max lg:max-w-7xl  mx-auto ">
        <div className="relative z-10 mb-8 md:mb-2 md:px-6">
          <div className="relative ">
            {/* Top right */}
            <CircleGrid
              position="absolute"
              right="-2rem"
              top="-2.5rem"
              color="#863d90"
              size="50px"
              className="hidden md:inline"
              zIndex={0}
            />

            {/* Top left */}
            <CircleGrid
              position="absolute"
              left="-2rem"
              bottom="-2.5rem"
              color="#863d90"
              className="hidden md:inline"
              size="80px"
              zIndex={0}
            />
            {/* Center right */}
            <CircleGrid
              position="absolute"
              right="-4rem"
              bottom="-15rem"
              color="#863d90"
              size="80px"
              className="hidden md:inline"
              zIndex={0}
            />
            {/* Bottom left */}
            <CircleGrid
              position="absolute"
              left="-4rem"
              bottom="-20rem"
              color="#863d90"
              className="hidden md:inline"
              size="50px"
              zIndex={0}
            />
            {/* Top left */}
            <Donut
              color="#863d90"
              top="7rem"
              left="-3rem"
              size="4rem"
              width={["0.5rem", "1rem", "1rem", "1rem"]}
              className="hidden lg:inline lg:animate-shape"
              zIndex={0}
            />
            {/* Bottom right */}
            <Donut
              color="#863d90"
              top="15rem"
              right="-3rem"
              size="4rem"
              width={["0.5rem", "1rem", "1rem", "1rem"]}
              className="hidden lg:inline lg:animate-shape"
              zIndex={0}
            />
          </div>
          <div className="text-base max-w-prose lg:max-w-none">
            {/* <h2 className="text-lg text-center font-semibold tracking-wider text-purple  uppercase ">
              Policies
            </h2> */}
            <p className="mb-5 sm:mb-0 text-center mt-2 text-5xl font-bold text-blue">
              TutorWo Policies
            </p>
            <div className="relative mt-2 md:bg-white flex flex-col justify-center items-center">
              <ul className="pl-8 lg:pl-20 mt-8 lg:mt-16 space-y-12 text-lg text-gray-500">
                {policies.c.map((item) => (
                  <li key={item.name}>
                    <a
                      className=" hover:text-yellow flex items-center"
                      href={item.href}
                      target="_blank"
                      rel="noreferrer">
                      <ArrowTopRightOnSquareIcon
                        className="flex-none w-5 h-5 mr-5 stroke-gray-500 stroke-2"
                        aria-hidden="true"
                      />
                      {item.name}
                    </a>
                  </li>
                ))}
                {policies.p.map((item) => (
                  <li key={item.name}>
                    <a
                      className=" hover:text-yellow flex items-center"
                      href={item.href}
                      target="_blank"
                      rel="noreferrer">
                      <ArrowTopRightOnSquareIcon
                        className="flex-none w-5 h-5 mr-5 stroke-gray-500 stroke-2"
                        aria-hidden="true"
                      />
                      {item.name}
                    </a>
                  </li>
                ))}
                {policies.r.map((item) => (
                  <li key={item.name}>
                    <a
                      className=" hover:text-yellow flex items-center"
                      href={item.href}
                      target="_blank"
                      rel="noreferrer">
                      <ArrowTopRightOnSquareIcon
                        className="flex-none w-5 h-5 mr-5 stroke-gray-500 stroke-2"
                        aria-hidden="true"
                      />
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Policies;
